import React from "react";
import { useLanguage } from "@/i18n/LanguageProvider";

/**
 * Compact EN / عربي pill toggle. Usable on light or dark backgrounds via `variant`.
 */
export default function LanguageToggle({ variant = "dark", className = "", testId = "lang-toggle" }) {
  const { lang, setLang } = useLanguage();
  const isDark = variant === "dark";

  const baseTrack = isDark
    ? "bg-white/10 border border-white/15"
    : "bg-delfi-cloud border border-delfi-navy/10";
  const inactive = isDark ? "text-white/65 hover:text-white" : "text-delfi-navy/60 hover:text-delfi-navy";
  const activeChip = "bg-delfi-red text-white shadow-[0_4px_12px_-4px_rgba(152,27,55,0.6)]";

  return (
    <div
      className={`inline-flex items-center rounded-full p-0.5 text-[11px] font-bold tracking-wide ${baseTrack} ${className}`}
      data-testid={testId}
      role="group"
      aria-label="Language switcher"
    >
      <button
        type="button"
        onClick={() => setLang("en")}
        className={`px-3 py-1.5 rounded-full transition-all duration-200 ${lang === "en" ? activeChip : inactive}`}
        aria-pressed={lang === "en"}
        data-testid="lang-toggle-en"
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLang("ar")}
        className={`px-3 py-1.5 rounded-full transition-all duration-200 font-arabic ${lang === "ar" ? activeChip : inactive}`}
        aria-pressed={lang === "ar"}
        data-testid="lang-toggle-ar"
      >
        عربي
      </button>
    </div>
  );
}
